import React, {useState, useCallback} from 'react';
import {compose} from 'recompose';
import styled from 'styled-components';
import {hot} from 'react-hot-loader';
import {Modal, Header, Icon, Button, Message, Form} from 'semantic-ui-react';

import {withLocale} from 'op/components/locale';
import {withReportKpi} from './kpi-modal.helper';

const MessageInfo = styled.div`
	white-space: pre-wrap;
`;


const KpiModal = ({locale, isOpen, readOnly, value, kpiremark}) => {
    const [openModal, setOpenModal] = useState(isOpen || false);

    return (
        <Modal
            trigger={
                <Icon style={{margin: 'auto 10px auto 0'}}
                      name={!(readOnly) ? 'question circle outline' : 'question circle'}
                      onClick={() => setOpenModal(true)}/>
            }
            open={openModal}
            onClose={() => setOpenModal(false)}
            style={{direction: locale._meta.rtl ? 'rtl' : 'ltr'}}
        >
            <Header icon='edit' content={value}/>
            <Modal.Content>
                <Form.Field>
                    <MessageInfo>
                        <Message
                            content={kpiremark || value}
                        />
                    </MessageInfo>
                </Form.Field>

            </Modal.Content>
            <Modal.Actions>

                <Button onClick={() => setOpenModal(false)} floated='right' primary style={{marginBottom: 20}}>
                    <Icon name='remove'/> {locale._system.close}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default compose(
    hot(module),
    withReportKpi,
    withLocale('report.descKpi'),
)(KpiModal);
